import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import PublicLayout from "@/components/layout/PublicLayout";
import RouteSEO from "@/components/RouteSEO";

import Home from "@/pages/Home";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import CurrentIssue from "@/pages/CurrentIssue";
import Archives from "@/pages/Archives";
import IssueDetail from "@/pages/IssueDetail";
import EditorialBoard from "@/pages/EditorialBoard";
import Contact from "@/pages/Contact";
import Submit from "@/pages/Submit";
import ContentPage from "@/pages/ContentPage";
import InstructionsForAuthors from "@/pages/InstructionsForAuthors";

import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminArticles from "@/pages/admin/AdminArticles";
import AdminIssues from "@/pages/admin/AdminIssues";
import AdminEditorialBoard from "@/pages/admin/AdminEditorialBoard";
import AdminContent from "@/pages/admin/AdminContent";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminEmails from "@/pages/admin/AdminEmails";
import PDFGenerator from "@/pages/admin/PDFGenerator";

const withLayout = (el) => <PublicLayout>{el}</PublicLayout>;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <I18nProvider>
          <Toaster position="top-right" richColors />
          <RouteSEO />
        <Routes>
          {/* Public */}
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/articles" element={withLayout(<Articles />)} />
          <Route path="/articles/:slug" element={withLayout(<ArticleDetail />)} />
          <Route path="/current-issue" element={withLayout(<CurrentIssue />)} />
          <Route path="/archives" element={withLayout(<Archives />)} />
          <Route path="/archives/:id" element={withLayout(<IssueDetail />)} />
          <Route path="/editorial-board" element={withLayout(<EditorialBoard />)} />
          <Route path="/contact" element={withLayout(<Contact />)} />
          <Route path="/submit" element={withLayout(<Submit />)} />
          <Route path="/about" element={withLayout(<ContentPage pageKey="about" defaultTitle="About the Journal" defaultSubtitle="A peer-reviewed digital journal of clinical & surgical research." />)} />
          <Route path="/aims-scope" element={withLayout(<ContentPage pageKey="aims_scope" defaultTitle="Aims and Scope" defaultSubtitle="The editorial focus of Clinical & Surgical Review." />)} />
          <Route path="/aims-and-scope" element={withLayout(<ContentPage pageKey="aims_scope" defaultTitle="Aims and Scope" defaultSubtitle="The editorial focus of Clinical & Surgical Review." />)} />
          <Route path="/authors" element={withLayout(<InstructionsForAuthors />)} />
          <Route path="/instructions-for-authors" element={withLayout(<InstructionsForAuthors />)} />
          <Route path="/peer-review" element={withLayout(<ContentPage pageKey="peer_review" defaultTitle="Peer Review Process" defaultSubtitle="How submitted manuscripts are reviewed." />)} />
          <Route path="/peer-review-process" element={withLayout(<ContentPage pageKey="peer_review" defaultTitle="Peer Review Process" defaultSubtitle="How submitted manuscripts are reviewed." />)} />
          <Route path="/ethics" element={withLayout(<ContentPage pageKey="ethics" defaultTitle="Publication Ethics" defaultSubtitle="Our commitment to research integrity." />)} />
          <Route path="/publication-ethics" element={withLayout(<ContentPage pageKey="ethics" defaultTitle="Publication Ethics" defaultSubtitle="Our commitment to research integrity." />)} />
          <Route path="/apc" element={withLayout(<ContentPage pageKey="apc" defaultTitle="Article Processing Charge" defaultSubtitle="Open-access fees only apply after acceptance." />)} />
          <Route path="/article-processing-charge" element={withLayout(<ContentPage pageKey="apc" defaultTitle="Article Processing Charge" defaultSubtitle="Open-access fees only apply after acceptance." />)} />
          <Route path="/privacy" element={withLayout(<ContentPage pageKey="privacy" defaultTitle="Privacy Policy" />)} />
          <Route path="/privacy-notice" element={withLayout(<ContentPage pageKey="privacy" defaultTitle="Privacy Policy" />)} />
          <Route path="/legal-notice" element={withLayout(<ContentPage pageKey="legal_notice" defaultTitle="Legal Notice" showUpdated />)} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="submissions" element={<AdminSubmissions />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="articles" element={<AdminArticles />} />
            <Route path="pdf-generator" element={<PDFGenerator />} />
            <Route path="issues" element={<AdminIssues />} />
            <Route path="editorial-board" element={<AdminEditorialBoard />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="emails" element={<AdminEmails />} />
          </Route>
        </Routes>
        </I18nProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
